import { ITheme, IColor, TColorOption } from '@unfold/theme';

export enum Variant {
  H100 = 'H100',
  H200 = 'H200',
  H300 = 'H300',
  H400 = 'H400',
  H500 = 'H500',
  H600 = 'H600',
  H700 = 'H700',
  H800 = 'H800',
  H900 = 'H900',
  Code = 'Code',
  Paragraph = 'Paragraph',
  Label = 'Label',
}

export type TVariant = keyof typeof Variant;

export type TAlign = 'left' | 'center' | 'right';

export enum GlobalColorKeyword {
  'Currentcolor' = 'currentcolor',
  'Inherit' = 'inherit',
  'Initial' = 'initial',
  'Unset' = 'unset',
}

export type TCustomColor =
  | keyof IColor
  | TOptionalToRequired<TColorOption>
  | keyof typeof GlobalColorKeyword;

export interface ITypographyProps {
  variant: TVariant;
  align?: TAlign;
  customColor?: TCustomColor;
  noWrap?: boolean;
  // TODO: This is only for label element here. Maybe later we can use
  // generics to conditionally extend the ITypographyProps
  htmlFor?: string;
  fontSize?: string | number;
  lineHeight?: string | number;
}

export type TGetColor = (
  component: string,
  theme: ITheme,
  customColor?: TCustomColor
) => string;
